import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';

const LoaderIcon = ({ animated = false, size = 24, strokeWidth = 1.3 }) => {
  const classes = classNames('ws-ui-loader-icon', {
    'ws-ui-loader-icon--animated': animated,
  });

  return (
    <div className={classes}>
      <Icon glyph="loader" type="accent" size={size} strokeWidth={strokeWidth} />
    </div>
  );
};

export default LoaderIcon;
